import { render, staticRenderFns } from "./printers_sis.vue?vue&type=template&id=09ffdc2e&scoped=true&"
import script from "./printers_sis.vue?vue&type=script&lang=js&"
export * from "./printers_sis.vue?vue&type=script&lang=js&"
import style0 from "./printers_sis.vue?vue&type=style&index=0&id=09ffdc2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ffdc2e",
  null
  
)

export default component.exports